export default "__VITE_ASSET__DXg5XAZA__"